import React from "react";
import Resolvers from "./resolvers/index.js";

class AdminConstants extends React.Component {

    state = {
        data: [],
        list: [],
        edit: {
            id: -1,
            open: false,
            majorKey: "",
            minorKey: "",
            value: ""
        }
    }

    Save = async () => {
        this.setState({ edit: { ...this.state.edit, open: false } });
        const data = await Resolvers(this.props.RESOLVERS.API, { ...this.props, ApiRes: "AdminConstantsPost", data: this.state.edit, successText: "Uložení konstanty proběhlo úspěšně", decryptData: true, jsonParseData: true })
        this.setState({ list: data.data });
    }

    Delete = async () => {
        this.setState({ edit: { ...this.state.edit, open: false } });
        const data = await Resolvers(this.props.RESOLVERS.API, { ...this.props, ApiRes: "AdminConstantsPost", data: this.state.edit, successText: "Uložení konstanty proběhlo úspěšně", decryptData: true, jsonParseData: true })
        this.setState({ list: data.data });
    }

    editConstat = async (id) => {
        this.setState({
            edit: {
                id: id,
                open: true,
                type: id > 0 ? "edit" : "add",
                majorKey: id > 0 ? this.state.list.filter((itm) => itm.id === id)[0].majorKey : this.state.list[0]?.majorKey ? this.state.list[0].majorKey : "",
                minorKey: id > 0 ? this.state.list.filter((itm) => itm.id === id)[0].minorKey : "",
                value: id > 0 ? this.state.list.filter((itm) => itm.id === id)[0].value : "",
                desc: id > 0 ? this.state.list.filter((itm) => itm.id === id)[0].desc : "",
            }
        })
    }

    GetByMajorKey = async (e) => {
        const data = await Resolvers(this.props.RESOLVERS.API, { ...this.props, ApiRes: "AdminConstatntsGetMajorKey", majorKey: e.value, successText: "Načtení konstant ze skupiny " + e.value + " proběhlo úspěšně", decryptData: true, jsonParseData: true })
        this.setState({ list: data.data });
    }

    async componentDidMount() {
        this.props.setHeaderPage({
            Icon: <this.props._icon icon="vscsymbolconstant" className="c-placeholder c-green" />,
            Title: "Administrace konstant",
            SubTitle: "",
        });
        this.setState(await Resolvers(this.props.RESOLVERS.API, { ...this.props, ApiRes: "AdminConstatntsGetList", successText: "Načtení konstant proběhlo úspěšně", decryptData: true, jsonParseData: true }))

    }

    render() {
        const { Bs, VARIANT, SIZE, _icon, loader } = this.props;

        return (<>
            {!loader.open && (
                <>
                    <Bs modal
                        show={this.state.edit.open}
                        onHide={() => this.setState({ edit: { open: false, id: -1 } })}
                        centered
                        size={SIZE.MD}
                        aria-labelledby="contained-modal-title-vcenter"
                        backdrop="static">
                        <Bs modalheader closeButton>
                            {this.state.edit.id > 0 ? "Editace konstanty č: " + this.state.edit.id : "Přidat novou konstantu"}
                        </Bs>
                        <Bs modalbody>
                            <Bs row className="mb-2">
                                <Bs col xs={12}>
                                    <Bs formcontrol value={this.state.edit.majorKey} onChange={(e) => this.setState({ edit: { ...this.state.edit, majorKey: e.target.value } })} />
                                    <Bs formtext>Skupina</Bs>
                                </Bs>
                            </Bs>
                            <Bs row className="mb-2">
                                <Bs col xs={12}>
                                    <Bs formcontrol value={this.state.edit.minorKey} onChange={(e) => this.setState({ edit: { ...this.state.edit, minorKey: e.target.value } })} />
                                    <Bs formtext>Klíč</Bs>
                                </Bs>
                            </Bs>
                            <Bs row className="mb-2">
                                <Bs col xs={12}>
                                    <Bs formcontrol as="textarea" rows={10} value={this.state.edit.value} onChange={(e) => this.setState({ edit: { ...this.state.edit, value: e.target.value } })} />
                                    <Bs formtext>Hodnota</Bs>
                                </Bs>
                            </Bs>
                            <Bs row className="mb-2">
                                <Bs col xs={12}>
                                    <Bs formcontrol as="textarea" rows={10} value={this.state.edit.desc} onChange={(e) => this.setState({ edit: { ...this.state.edit, desc: e.target.value } })} />
                                    <Bs formtext>Popis</Bs>
                                </Bs>
                            </Bs>
                        </Bs>
                        <Bs modalfooter>
                            <Bs row>
                                <Bs col xs={12} className="d-flex justify-content-between">
                                    {this.state.edit.id > 0 && 1 === 0 ?
                                        <Bs button variant={VARIANT.DANGER} className="me-4" size={SIZE.SM}>{this.state.edit.id > 0 ? "Smazat" : ""}</Bs>
                                        :
                                        <Bs span>&nbsp;</Bs>
                                    }
                                    <Bs button variant={VARIANT.SUCCESS} size={SIZE.SM} onClick={this.Save}>{this.state.edit.id > 0 ? "Upravit" : "Přidat"}</Bs>
                                </Bs>
                            </Bs>

                        </Bs>
                    </Bs>
                    <Bs card bg={VARIANT.UNI} className="mb-4">
                        <Bs cardbody>
                            <Bs row>
                                <Bs col xs={12} className="d-flex justify-content-between">
                                    <Bs col xs={4}>
                                        <Bs brtxselect options={this.state.data} onChange={this.GetByMajorKey} className="w-350" placeholder="Vyber typ konstanty" />
                                    </Bs>
                                    <Bs button size={SIZE.SM} variant={VARIANT.SUCCESS} onClick={() => this.editConstat(0)}>Přidat konstantu</Bs>
                                </Bs>
                            </Bs>
                        </Bs>
                    </Bs>
                    {this.state.list.map((c) => (
                        <Bs card bg={VARIANT.WHITE} className="mb-2 lb-3-secondary" data-tip={c.desc}>
                            <Bs cardbody>
                                <Bs row className="mb-1">
                                    <Bs col xs={1} className="d-flex justify-content-between align-items-center">
                                        <Bs span>{c.id}</Bs>
                                    </Bs>
                                    <Bs col xs={5} className="d-flex justify-content-between align-items-center">
                                        <Bs span>{c.majorKey}</Bs>
                                    </Bs>
                                    <Bs col xs={5} className="d-flex justify-content-between align-items-center">
                                        <Bs span>{c.minorKey}</Bs>
                                    </Bs>
                                    <Bs col xs={1} className="d-flex justify-content-between align-items-center">
                                        <Bs button data-tip="upravit konstantu" variant={VARIANT.LIGHT} onClick={() => this.editConstat(c.id)}><_icon icon="ioellipsisvertical" className="c-dark" /></Bs>
                                    </Bs>
                                </Bs>
                            </Bs>
                        </Bs>
                    ))}
                </>
            )}
        </>)
    }
}
export default AdminConstants;